export enum ESourceRefreshFrequency {
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  MultipleTimesPerWeek = 'MultipleTimesPerWeek',
  NotScheduled = 'NotScheduled',
  OnDemand = 'OnDemand',
}

export type TDataRefreshPccDetail = {
  pccName: string;
};

export type TDataRefreshDetail = {
  fiscalYear: number;
  sourceName: string;
  pccDetails: TDataRefreshPccDetail[];
  lastSourceRefreshDateTime?: string | null;
  lastReportRefreshDateTime?: string | null;
  nextReportRefreshDateTime?: string | null;
  nextSourceRefreshFrequency?: ESourceRefreshFrequency | string;
};

export type TDataRefreshDetails = TDataRefreshDetail[];
